
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import api from '../../api';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
XButton,
Icon,
},
mounted() {
this.id = this.$route.query.id;
this.getContact();
},
activated() {
},
watch: {
},
data() {
return {
empty: false,
contactList: [],
defaultMan: {},
};
},
computed: {
},
methods: {
save() {
this.$router.push({
name: 'hall.confirmApplication',
query: {
id: this.id,
defaultManID: this.defaultMan.id
}
});
console.log(this.contactList)
},
gotoEditLink(item) {
this.$router.push({
name: 'mineEditLinkman',
query: item,
});
},
getContact() {
api.vega.contact.listContacts({
pageNo: 1,
pageSize: 100,
}).then((res) => {
const data = res.data.data.result;
data.map((item) => {
if (item.status === 1) {
this.defaultMan = item;
}
return item;
});
this.contactList = data;
if (data.length === 0) {
this.empty = true;
} else {
this.empty = false;
}
});
},
checkItem(id) {
this.defaultMan = {};
this.contactList.map((item) => {
item.status = 0;
if (item.id === id) {
item.status = 1;
this.defaultMan = item;
}
});
},
},
};
